import React, { useEffect, useState, useCallback } from 'react';
import API from 'api';
import { swalAlert } from 'utils';

const UserProfile = ({ onSaved = null }) => {
  const [user, setUser] = useState(null);
  const [isValidEmail, setIsValidEmail] = useState(true);

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    try {
      const response = await API.get('/user/profile');
      setUser(response.data);
    } catch (error) {
      console.log(error);
      swalAlert("Vos données n'ont pu être chargées");
    }
  };

  const checkEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValidEmail(emailRegex.test(email));
  };

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;

    setUser(prev => ({
      ...prev,
      [name]: value
    }));
    if (name === 'userEmail') {
      checkEmail(value);
    }
  }, []);
  const handleSave = async () => {
    try {
      API.handleError = false;
      const response = await API.put('/user/profile', user);
      if (response.data?.error) {
        swalAlert(response.data.error.message || "Erreur lors de la sauvegarde", "error");
        return;
      }

      setUser({ ...response.data });
      console.log(onSaved)
      if (onSaved) {
        onSaved();
      } else {
        swalAlert("Vos données ont été mises à jour", "success");
      }
    } catch (error) {
      console.log(error)
      swalAlert(
        error?.response?.data?.error?.message || "Erreur serveur",
        "error"
      );
    }
  };

  if (!user) {
    return <div>Chargement des données...</div>;
  }

  return (
    <div className="user-profile">
      <form className="px-3">





        <div class="row">
          <div className='col-sm-6'>        <div className="form-group">
            <label className="form-label">Prénom : <span class="required"></span>  </label>
            <input
              type="text" required={true}
              className="form-control form-control-sm"
              name="userFirstname"
              value={user.userFirstname || ''}
              onChange={handleChange}
              autoComplete="given-name"
            />
          </div></div>
          <div className='col-sm-6'>
            <div className="form-group">
              <label className="form-label">Nom : <span class="required"></span>  </label>
              <input
                type="text" required={true}
                className="form-control form-control-sm"
                name="userName"
                value={user.userName || ''}
                onChange={handleChange}
                autoComplete="family-name"
              />
            </div></div>
        </div>
        <div class="row">

          <div className='col-sm-6'>
            <div className="form-group">
              <label className="form-label">Téléphone : <span class="required"></span>  </label>
              <input
                type="tel"
                className="form-control form-control-sm"
                name="userPhone"
                value={user.userPhone || ''}
                onChange={handleChange}
                autoComplete="tel"
              />
            </div></div>
        </div>
        <div className="form-group">
          <label className="form-label">Entreprise : </label>
          <input
            type="text" className="form-control form-control-sm"
            name="userCompName"
            value={user.userCompName || ''}
            onChange={handleChange}
            autoComplete="organization"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Adresse : <span class="required"></span>  </label>
          <textarea
            type="text" required={true}
            className="form-control form-control-sm"
            name="userAddress"
            value={user.userAddress || ''}
            onChange={handleChange}
            autoComplete="street-address"
          />
        </div>



        <div class="row">
          <div className='col-sm-4'>        <div className="form-group">
            <label className="form-label">Code postal : <span class="required"></span>  </label>
            <input
              type="text" required={true}
              className="form-control form-control-sm"
              name="userPostcode"
              value={user.userPostcode || ''}
              onChange={handleChange}
              autoComplete="postal-code"
            />
          </div></div>
          <div className='col-sm-8'>
            <div className="form-group">
              <label className="form-label">Ville : <span class="required"></span>  </label>
              <input
                type="text" required={true}
                className="form-control form-control-sm"
                name="userCity"
                value={user.userCity || ''}
                onChange={handleChange}
                autoComplete="address-level2"
              />
            </div></div>
        </div>







        <div className="form-group mb-5">
          <label className="form-label">Pays : <span class="required"></span>  </label>
          <input
            type="text" required={true}
            className="form-control form-control-sm"
            name="userCountry"
            value={user.userCountry || ''}
            onChange={handleChange}
            autoComplete="country-name"
          />
        </div>


        <button
          type="button"
          className="btn btn-primary rounded-pill"
          disabled={!isValidEmail}
          onClick={handleSave}
        >
          Sauvegarder
        </button>
      </form>
    </div>
  );
};

export default UserProfile;
